import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();
  
  private messageLanding = new BehaviorSubject('default message landing');
  currentMessageLanding = this.messageLanding.asObservable();
  
  private messageToken = new BehaviorSubject('default message token');
  currentMessageToken = this.messageToken.asObservable();

  private messageBredCrumb = new BehaviorSubject('');
  currentmessageBredCrumb = this.messageBredCrumb.asObservable();

  // **** 2025-12-01 JFRH: New BehaviorSubject to handle parameters across External Report APIs components **** //
  private messageExtRep = new BehaviorSubject('default message external report');
  currentMessageExtRep = this.messageExtRep.asObservable();
  

  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
    
    console.log(message);
  }
  miFuncionInyectada (){
    return this.messageSource;

  }
  changeMessagelanding(messagelandiging: string) {
    this.messageLanding.next(messagelandiging)
    
    console.log(messagelandiging);
  }
  mifuncionInyectadaLanding (){
    return this.messageLanding;
  }
  
  changeMessagetoken(messagetoken: string) {
    this.messageToken.next(messagetoken)
    
    console.log(messagetoken);
  }
  mifuncionInyectadaToken (){
    return this.messageToken;
  }

  setBreadCrumbData(messageFn: any){
    this.messageBredCrumb.next(messageFn)
  }

  getBreadCrumbData(){
    return this.messageBredCrumb;
  }

  // **** 2025-12-01 JFRH: New methods to handle parameters across External Report APIs components **** //
  changeMessageExtRep(messageExtRep: string) {
    this.messageExtRep.next(messageExtRep)
  }
  miFuncionInyectadaExtRep (){
    return this.messageExtRep;

  }
}
